import YesNoSecurity from "@/enumerations/Security/YesNoSecurity";
import SecuritySettingsBase from "./SecuritySettingsBase";

export default class OilEnergySecuritySettings extends SecuritySettingsBase {
  private static instance: OilEnergySecuritySettings;

  private constructor() {
    super();
  }

  public static getInstance(): OilEnergySecuritySettings {
    if (!OilEnergySecuritySettings.instance) {
      OilEnergySecuritySettings.instance = new OilEnergySecuritySettings();
    }

    return OilEnergySecuritySettings.instance;
  }

  /**
   * The whole section is hidden for a customer who is not flagged as Oil & Energy in Merchant, whatever the
   * parameters say. The legacy portal draws the same line.
   */
  private get showOilEnergy(): boolean {
    return (
      !this.isManagerAccountSelected &&
      (this.selectedAccount?.isOilEnergyCustomer ?? false) &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.oilEnergy,
        YesNoSecurity.yes
      )
    );
  }

  public get showOilEnergyMenu(): boolean {
    return (
      this.showOilEnergy &&
      (this.showTanksPage ||
        this.showDeliveryPage ||
        this.showBudgetBillingPage ||
        this.showLeaseAgreementsPage ||
        this.showEnergyAssistancePage ||
        this.showSalesContractsPage)
    );
  }

  public get showTanksPage(): boolean {
    return (
      this.parameters.showTanks &&
      this.showOilEnergy &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewTankInformation,
        YesNoSecurity.yes
      )
    );
  }

  public get showDeliveryPage(): boolean {
    return (
      this.parameters.showOilEnergyDeliveries &&
      this.showOilEnergy &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewOilEnergyDelivery,
        YesNoSecurity.yes
      )
    );
  }

  public get showBudgetBillingPage(): boolean {
    return (
      this.parameters.showBudgetBilling &&
      this.showOilEnergy &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewBudgetBilling,
        YesNoSecurity.yes
      )
    );
  }

  public get showLeaseAgreementsPage(): boolean {
    return (
      this.parameters.showLeaseAgreements &&
      this.showOilEnergy &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewLeaseAgreements,
        YesNoSecurity.yes
      )
    );
  }

  public get showEnergyAssistancePage(): boolean {
    return (
      this.parameters.showEnergyAssistance &&
      this.showOilEnergy &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewEnergyAssistance,
        YesNoSecurity.yes
      )
    );
  }

  public get showSalesContractsPage(): boolean {
    return (
      this.parameters.showSalesContracts &&
      this.showOilEnergy &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewSalesContracts,
        YesNoSecurity.yes
      )
    );
  }

  /**
   * Whether one of these pages may be shown, named by the permission its route carries. Oil & Energy is the one
   * section whose rights belong to the account rather than to the login, so the answer changes when the grower
   * switches account and the question is asked again then, not only on navigation.
   */
  public canShowPage(oilEnergyPermission: string): boolean {
    switch (oilEnergyPermission) {
      case "tanks":
        return this.showTanksPage;
      case "delivery":
        return this.showDeliveryPage;
      case "budgetBilling":
        return this.showBudgetBillingPage;
      case "leaseAgreements":
        return this.showLeaseAgreementsPage;
      case "energyAssistance":
        return this.showEnergyAssistancePage;
      case "salesContracts":
        return this.showSalesContractsPage;
      default:
        return true;
    }
  }
}
